import { useMutation } from "@tanstack/react-query";
import { useState } from "react";

import { api, type CandidateDetails } from "../../api/client";

const empty = (value: string) => (value.trim() ? value.trim() : null);

export function DetailsStep({
  initial,
  onDone,
}: {
  initial: CandidateDetails;
  onDone: () => void;
}) {
  const [role, setRole] = useState(initial.role_interest ?? "");
  const [portfolio, setPortfolio] = useState(initial.portfolio ?? "");
  const [linkedin, setLinkedin] = useState(initial.linkedin ?? "");
  const save = useMutation({ mutationFn: api.updateDetails, onSuccess: onDone });

  return (
    <section>
      <h1>A few optional details</h1>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          save.mutate({
            role_interest: empty(role),
            portfolio: empty(portfolio),
            linkedin: empty(linkedin),
          });
        }}
      >
        <label htmlFor="role">Which kind of role interests you?</label>
        <input id="role" maxLength={120} value={role} onChange={(e) => setRole(e.target.value)} />
        <label htmlFor="portfolio">Portfolio URL</label>
        <input
          id="portfolio"
          type="url"
          value={portfolio}
          onChange={(e) => setPortfolio(e.target.value)}
        />
        <label htmlFor="linkedin">LinkedIn URL</label>
        <input
          id="linkedin"
          type="url"
          value={linkedin}
          onChange={(e) => setLinkedin(e.target.value)}
        />
        {save.isError && <p role="alert">{save.error.message}</p>}
        <div className="actions">
          <button type="submit" disabled={save.isPending}>
            Save and continue
          </button>
          <button type="button" className="secondary" onClick={onDone}>
            Skip
          </button>
        </div>
      </form>
    </section>
  );
}
